import React from 'react';
import { NotesWorkspace } from '../workspace/NotesWorkspace';

export default function AppPage() {
  return <NotesWorkspace />;
}
